
import Nav from 'react-bootstrap/Nav';
import { INavBarItem } from '../../../types/menu';

import NavItemComponent from "./NavItemComponent";

function MobileMenuComponent({items}:any) {
  return (
    <div className="nav-body">
          <div className="nav-bodyInner">
        <Nav className="nav justify-content-center" as="ul">
          {items.map((item: INavBarItem, index: number) => (
            <NavItemComponent {...item} />
          ))}
        </Nav>
          
          </div>
        </div>
  );
}

export default MobileMenuComponent;

